class AutoSpin {
    constructor(controls) {
        this._controls = controls;
        this._objects = new Map();

        controls.events.addEventListener("grab", this._grabObject.bind(this));
        controls.events.addEventListener("release", this._releaseObject.bind(this));
    }

    _setObjectAutoSpin(object, enabled, speed, delay) {
        let autoSpin = this._objects.get(object);

        if (autoSpin) {
            if (autoSpin.timeout) {
                clearTimeout(autoSpin.timeout);
                autoSpin.timeout = null;
            } else this._controls.setAutoSpin(object, false);

            if (!enabled) this._objects.delete(object);
        }

        if (enabled) {
            if (!autoSpin) {
                autoSpin = { timeout: null };

                this._objects.set(object, autoSpin);
            }

            autoSpin.timeout = setTimeout(() => {
                this._controls.setAutoSpin(object, true, speed / 30);
                autoSpin.timeout = null;
            }, Q3.editMode ? 0 : delay * 1000);
        }
    }

    _clearObject(object) { this._setObjectAutoSpin(object, false); }

    applyObjectCurrentSlide(object) {
        const animData = Q3.SlideManager.currentSlide.animation[object.uuid];
        const autoSpin = animData && animData.autoSpin;

        if (autoSpin) {
            const { enabled, speed, delay } = autoSpin;
            this._setObjectAutoSpin(object, enabled, speed, delay);
        } else this._setObjectAutoSpin(object, false);
    }

    _grabObject({ object }) { this._clearObject(object); }
    _releaseObject({ object }) { this.applyObjectCurrentSlide(object); }

    clearAutoSpin() {
        for (let uuid in Q3.data.assets.objects) {
            const object = Q3.assets.objects[uuid];

            this._clearObject(object);
        }
    }

    setAutoSpinFromSlide() {
        for (let uuid in Q3.data.assets.objects) {
            const object = Q3.assets.objects[uuid];
            if (object) this.applyObjectCurrentSlide(object);
        }
    }
}

export default AutoSpin;
export { AutoSpin };
